<script setup>
import { defineProps } from 'vue'
import Row from './Row.vue'

const props = defineProps({
    expandedCriterias: Object,
    isActivitiesJob: Boolean
})

function ToggleChilds(parent) {
    parent.showChildren = !parent.showChildren
    parent.show = !parent.show
}
</script>

<template>
    <div class="div-job-activities">
        <div class="div-activity-title">
            <slot name="title"></slot>
        </div>

        <div v-for="activity in props.expandedCriterias" :key="activity.id" class="row">
            <div :class="{ 'div-activity': props.isActivitiesJob, 'div-extra-job': !props.isActivitiesJob }">
                <Row :element="activity" @toggle-childs="ToggleChilds($event)"/>
            </div>

            <div v-show="activity.show">
                <div class="div-task-container" v-for="task in activity.children" :key="task.id">
                    <div class="div-task">
                        <Row :element="task" @toggle-childs="ToggleChilds($event)"/>
                    </div>

                    <div class="div-skills-container" v-show="task.show">
                        <div v-for="skill in task.children" :key="skill.id">
                            <div class="div-skill">
                                <Row :element="skill" />
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    </div>
</template>

<style scoped>
.div-activity-title {
    margin: 10px 0;
    font-weight: bold;
    font-size: 1.2em;
    text-transform: uppercase;
}

.div-task {
    background-color: var(--default-app-alt-line-color);
}

.div-extra-job,
.div-activity {
    background-color: #2f70d9;
    margin-top: 10px;
}

.div-task,
.div-activity,
.div-extra-job,
.div-skill {
    padding: 5px 5px 5px 10px;
    display: flex;
    align-items: center;
    height: 30px;
    justify-content: space-between;
}

.div-skill {
    padding: 0px;
    height: 25px;
    padding-left: 10px;
    padding-right: 5px;
}

.div-task-container {
    padding: 2px 0px 0px 20px;
}

.div-skills-container {
    display: flex;
    flex-direction: column;
    margin-top: 2px;
    gap: 5px;
}

</style>